var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Top" },
    _vm._l(_vm.topList, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "current",
          class: _vm.active == item.to ? "checkTab" : "",
          on: {
            click: function ($event) {
              ;(_vm.active = item.to), _vm.$emit("Select", item.to)
            },
          },
        },
        [_vm._v(_vm._s(item.name))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }